exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Z3P416TIr4ViFcEeprAdS{left:0;top:0;right:0;bottom:0;background:#fff;z-index:9999999}", "", {"version":3,"sources":["/home/gitlab-runner/builds/kt-nMe54/0/btcc-group/app-fo/src/pages/Online/styles.module.scss"],"names":[],"mappings":"AAAA,uBAAS,OAAO,MAAM,QAAQ,SAAS,gBAAgB,eAAe,CAAC","file":"styles.module.scss","sourcesContent":[".loading{left:0;top:0;right:0;bottom:0;background:#fff;z-index:9999999}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"loading": "Z3P416TIr4ViFcEeprAdS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true,"modules":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/pages/Online/styles.module.scss
// module id = 355
// module chunks = 11